<template>
	<div class="gnb-root" :class="rootClasses">

		<!-- ── FAB (solo en modo standalone) ── -->
		<transition name="gnb-fab-pop">
			<button
				v-if="!isOpen && !controlled"
				class="gnb-fab"
				@click="openMenu"
				aria-label="Nuevo elemento"
			>
				<v-icon color="white" size="22">mdi-view-grid-plus-outline</v-icon>
			</button>
		</transition>

		<!-- ── Panel ── -->
		<transition name="gnb-win-slide">
			<div
				v-if="isOpen"
				class="gnb-panel"
				:style="{ transformOrigin: anchor === 'left' ? 'bottom left' : 'bottom right' }"
				role="dialog"
				aria-label="Nuevo elemento"
			>
				<div class="gnb-header">
					<span class="gnb-header__title">Nuevo elemento</span>
					<v-btn icon x-small @click="closeMenu" title="Cerrar" class="gnb-icon-btn">
						<v-icon size="15" color="rgba(255,255,255,.65)">mdi-close</v-icon>
					</v-btn>
				</div>

				<div class="gnb-list">
					<button class="gnb-item" @click="createTarea">
						<div class="gnb-item-icon"><v-icon small color="#2D4B95">mdi-clipboard-text-outline</v-icon></div>
						<span>Nueva Tarea</span>
						<v-icon class="gnb-item-arrow" x-small>mdi-plus</v-icon>
					</button>

					<button class="gnb-item" @click="createRdi">
						<div class="gnb-item-icon"><v-icon small color="#2D4B95">mdi-file-document-multiple-outline</v-icon></div>
						<span>Nueva RDI</span>
						<v-icon class="gnb-item-arrow" x-small>mdi-plus</v-icon>
					</button>

					<button class="gnb-item" @click="createAdicional">
						<div class="gnb-item-icon"><v-icon small color="#2D4B95">mdi-notebook-plus-outline</v-icon></div>
						<span>Nuevo Adicional</span>
						<v-icon class="gnb-item-arrow" x-small>mdi-plus</v-icon>
					</button>

					<button class="gnb-item" @click="createPosibleAdicional">
						<div class="gnb-item-icon"><v-icon small color="#2D4B95">mdi-notebook-plus-outline</v-icon></div>
						<span>Nuevo Posible Adicional</span>
						<v-icon class="gnb-item-arrow" x-small>mdi-plus</v-icon>
					</button>

					<button class="gnb-item" @click="createEntrega">
						<div class="gnb-item-icon"><v-icon small color="#2D4B95">mdi-format-list-checks</v-icon></div>
						<span>Nueva Entrega</span>
						<v-icon class="gnb-item-arrow" x-small>mdi-plus</v-icon>
					</button>

					<button class="gnb-item" @click="createMeeting">
						<div class="gnb-item-icon"><v-icon small color="#2D4B95">mdi-calendar</v-icon></div>
						<span>Nueva Reunión/Minuta</span>
						<v-icon class="gnb-item-arrow" x-small>mdi-plus</v-icon>
					</button>
				</div>
			</div>
		</transition>

	</div>
</template>

<script>
export default {
	name: 'NewButtons',
	props: {
		fixed: { type: Boolean, default: false },
		// Modo controlado: la apertura/cierre la maneja un componente padre
		// (ej. GlobalFloatingButtons) a través de la prop `open`.
		controlled: { type: Boolean, default: false },
		open: { type: Boolean, default: false },
		// Lado hacia el que se ancla/expande el panel ('left' | 'right')
		anchor: { type: String, default: 'right' }
	},
	data: () => ({
		isOpen: false
	}),
	computed: {
		rootClasses() {
			const classes = []
			if (this.fixed) classes.push('gnb-fixed')
			if (this.controlled) classes.push('gnb-controlled-' + this.anchor)
			return classes
		}
	},
	watch: {
		open(val) {
			if (!this.controlled) return
			this.isOpen = val
		}
	},
	methods: {
		openMenu() {
			this.isOpen = true
		},
		closeMenu() {
			this.isOpen = false
			if (this.controlled) this.$emit('close')
		},
		createTarea() {
			this.$store.consultasStore.commit('setCreateTareaModal', true)
			this.closeMenu()
		},
		createRdi() {
			this.$store.rdiStore.commit('setCreateRDIModal', true)
			this.closeMenu()
		},
		createAdicional() {
			this.$store.adicionalesStore.commit('setCreateAdicionalModal', true)
			this.closeMenu()
		},
		createPosibleAdicional() {
			this.$store.adicionalesStore.commit('setCreatePosibleAdicionalModal', true)
			this.closeMenu()
		},
		createEntrega() {
			this.$store.entregaStore.commit('setCreateEntregaModal', true)
			this.closeMenu()
		},
		createMeeting() {
			this.$store.meetingStore.commit('setCreateMeetingModal', true)
			this.closeMenu()
		}
	}
}
</script>

<style scoped>
.gnb-root {
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
	pointer-events: auto !important;
}

.gnb-fixed {
	position: fixed;
	bottom: 10px;
	right: 10px;
	z-index: 9998;
}

/* Modo controlado: el panel se posiciona solo (el FAB lo maneja el padre) */
.gnb-controlled-left {
	position: fixed;
	bottom: 10px;
	left: 10px;
	z-index: 9998;
}
.gnb-controlled-right {
	position: fixed;
	bottom: 10px;
	right: 10px;
	z-index: 9998;
}

/* ── FAB ── */
.gnb-fab {
	width: 50px;
	height: 50px;
	border-radius: 50%;
	background: #1C3A7A;
	border: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 4px 18px rgba(28, 58, 122, .45);
	transition: background .18s, transform .15s, box-shadow .18s;
}
.gnb-fab:hover {
	background: #2D4B95;
	transform: scale(1.06);
	box-shadow: 0 6px 24px rgba(28, 58, 122, .6);
}

/* ── Panel ── */
.gnb-panel {
	width: 260px;
	border-radius: 12px;
	background: #ffffff;
	box-shadow: 0 20px 60px rgba(0,0,0,.18), 0 4px 16px rgba(0,0,0,.1);
	border: 1px solid #E0E6F5;
	overflow: hidden;
	pointer-events: auto !important;
}

.gnb-header {
	background: #1C3A7A;
	padding: 13px 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.gnb-header__title {
	font-size: 13px;
	font-weight: 600;
	color: #fff;
	line-height: 1.2;
}
.gnb-icon-btn {
	background: rgba(255,255,255,.08) !important;
	transition: background .15s !important;
}
.gnb-icon-btn:hover { background: rgba(255,255,255,.2) !important; }

/* ── Lista ── */
.gnb-list {
	display: flex;
	flex-direction: column;
	padding: 6px;
}

.gnb-item {
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	background: none;
	border: none;
	cursor: pointer;
	text-align: left;
	padding: 8px 8px;
	border-radius: 6px;
	font-size: 13px;
	font-weight: 500;
	color: #2D4B95;
	transition: background .12s ease;
}
.gnb-item:hover {
	background: rgba(45, 75, 149, 0.06);
}
.gnb-item:hover .gnb-item-icon {
	background: rgba(45, 75, 149, 0.16);
}
.gnb-item:hover .gnb-item-arrow {
	opacity: 1;
}

.gnb-item-icon {
	width: 28px;
	height: 28px;
	border-radius: 6px;
	background: rgba(45, 75, 149, 0.08);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	transition: background .12s;
}

.gnb-item span {
	flex: 1;
}

.gnb-item-arrow {
	opacity: 0;
	transition: opacity .12s;
}

/* ── Transiciones ── */
.gnb-fab-pop-enter-active { animation: gnb-pop-in .22s cubic-bezier(.34,1.56,.64,1); }
.gnb-fab-pop-leave-active { animation: gnb-pop-in .15s ease reverse; }

.gnb-win-slide-enter-active { animation: gnb-win-in .26s cubic-bezier(.16,1,.3,1); }
.gnb-win-slide-leave-active { animation: gnb-win-in .18s ease reverse; }

@keyframes gnb-pop-in {
	from { transform: scale(.5); opacity: 0; }
	to   { transform: scale(1);  opacity: 1; }
}
@keyframes gnb-win-in {
	from { transform: scale(.88) translateY(12px); opacity: 0; }
	to   { transform: scale(1)   translateY(0);    opacity: 1; }
}

/* ── Responsive ── */
@media (max-width: 420px) {
	.gnb-fixed { bottom: 12px; right: 12px; }
	.gnb-controlled-left { bottom: 12px; left: 12px; }
	.gnb-controlled-right { bottom: 12px; right: 12px; }
	.gnb-panel { width: calc(100vw - 24px); }
}
</style>